import { NotificationTypes, SafeAny } from '@/common/types';
import { FinalReportResponse } from '@/modules/report/types';
import { axiosInstance } from '@/common/utils';

export const getFinalReportDownloadUrl = async (
  { rootState, state, commit }: SafeAny,
  payload: { sleepStudyID: string; scoreSet: string }
) => {
  const url = `${rootState.env.requestUrl.reports}/studies/${payload.sleepStudyID}/download-report/`;

  state.finalReport.isLoading = true;

  try {
    const response = await axiosInstance.get<FinalReportResponse>(url);
    state.finalReport.isLoading = false;
    state.finalReport.data = response.data;
  } catch (error: SafeAny) {
    state.finalReport.isLoading = false;
    state.finalReport.data = undefined;
    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetReports',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
